import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import scrollToComponent from 'react-scroll-to-component';

const injectJuiceboxScripts = () => {
  const juiceBoxScript = injectScript('/bestof/juicebox/jbcore/juicebox.js');

  juiceBoxScript.onload = () => {
    injectScript('/bestof/bestof.js');
  };
};

const injectScript = url => {
  const script = document.createElement('script');
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
  return script;
};

class BestOf extends Component {
  constructor(props) {
    super(props);
    window.sgId = this.props.sgId;
  }

  componentDidMount() {
    injectJuiceboxScripts();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shouldExpandBestOf) {
      scrollToComponent(this.outerContainer, {
        align: 'top',
      });
    }
  }

  ref = element => {
    this.outerContainer = element;
  };

  render() {
    return (
      <div className="row">
        <div className="col-xs-16 col-sm-12 col-sm-offset-2">
          <div
            ref={this.ref}
            className={
              'bestof-outer-container ' +
              ((this.props.expanded || this.props.shouldExpandBestOf) &&
                'bestof-expanded')
            }
          >
            <h1 className="separator">
              <FormattedMessageWrappedInSpan
                id="bestOf.title"
                defaultMessage="Bestof-Gallery"
              />
            </h1>
            <div className="bestof-gallery-container">
              <div className="juicebox-container" id="juicebox-container" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BestOf.propTypes = {
  expanded: PropTypes.bool,
  sgId: PropTypes.number,
  shouldExpandBestOf: PropTypes.bool,
};

export default BestOf;
